import { CustomElement, resolve } from 'aurelia';
import { AccountService } from '../../services';
import template from './profile-modal.html';
import './profile-modal.css';

// Notification-settings modal (daily digest + per-item master switches). Renders only while
// AccountService.profileOpen is set; reuses the shared modal shell and adds toggle rows. All
// state and the save/close behavior live in AccountService.
export class ProfileModalElement {
  readonly account: AccountService = resolve(AccountService);
}

export const ProfileModal = CustomElement.define({
  name: 'profile-modal',
  template
}, ProfileModalElement);
